import { Collection } from 'core/model';
import { computed } from 'mobx';
import $auth from 'app/stores/$auth';
import ChatSessionModel from './ChatSessionModel';

class ChatSessionCollection extends Collection {
  get model() {
    return ChatSessionModel;
  }

  get url() {
    return '/api/ui/kaizen/listChatSessions';
  }

  searchChats(query) {
    if (!query || typeof query !== 'string' || query.trim().length === 0) {
      return this.clearFilters();
    }

    return this.filter((chat) => {
      const title = chat.get('session_title') || chat.get('user_title') || '';
      return title.toLowerCase().includes(query.toLowerCase());
    });
  }

  @computed
  get userChats() {
    const userId = $auth.getActiveUserProperty('id');
    return this.models
      .filter((chat) => chat.get('user_id') === userId)
      .sort((a, b) => {
        const aPinned = a.get('pinned') ? 1 : 0;
        const bPinned = b.get('pinned') ? 1 : 0;
        return bPinned - aPinned || new Date(b.get('updated_at')) - new Date(a.get('updated_at'));
      });
  }

  @computed
  get companyChats() {
    const userId = $auth.getActiveUserProperty('id');
    return this.models
      .filter((chat) => !chat.isKProxyUserChat)
      .filter((chat) => chat.get('user_id') !== userId)
      .sort((a, b) => new Date(b.get('updated_at')) - new Date(a.get('updated_at')));
  }
}

export default ChatSessionCollection;
